export const newServiceDefaults = {
    id: crypto.randomUUID(),
    name: '',
    description: '',
    reference: '',
    dataverseId: '',
};
